import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


export default class Ticker {
	constructor(ticker) {

		this.ticker 				= ticker;
		this.track 					= this.ticker.querySelector('.promo-ticker__group');
		this.init 					= this.init.bind(this)

		this.init()

	}

	init() {

		const scrollTickerAnimation = GSAP.timeline({ 
			paused: true,
			scrollTrigger: {
				trigger: this.track,
				scrub: 0.1,
				start: "top bottom",
				end: "bottom -200%",
			},
		})

		scrollTickerAnimation.to(this.track, {
			xPercent: -10,
			transformOrigin: "left center",
			ease: "none",
			// repeat: true,
			// duration: 10,
			// onComplete: ()=> {
			// 	console.log(`complete!`)
			// }
		})

	}
}
